function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesDvdFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 10.258c.357.843.63 1.728.817 2.63a14.179 14.179 0 010 5.641c-.186.902-.46 1.787-.816 2.63a14.094 14.094 0 01-1.293 2.378c-.256.38-.535.747-.829 1.101v-3.683l.086-.172c.068-.133.135-.266.194-.404.303-.72.54-1.479.698-2.252a12.14 12.14 0 000-4.839 12.132 12.132 0 00-.699-2.25 12.013 12.013 0 00-2.572-3.815 12.004 12.004 0 00-6.067-3.272 12.24 12.24 0 00-4.838 0 12.023 12.023 0 00-9.337 9.338 12.148 12.148 0 000 4.84c.16.771.394 1.53.7 2.25.06.145.132.287.203.428l.073.149v3.682A13.96 13.96 0 012 15.708c0-.948.096-1.896.284-2.82A14.016 14.016 0 014.391 7.88a14.19 14.19 0 013.78-3.78 13.998 13.998 0 015.009-2.108 14.246 14.246 0 015.64 0A13.97 13.97 0 0125.9 5.81c.634.634 1.209 1.33 1.71 2.071.503.746.938 1.546 1.29 2.378z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.35 15.709h-2a8.291 8.291 0 00-2.446-5.904l1.414-1.414a10.274 10.274 0 013.031 7.318z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.073 23.416c1.649 0 2.84 1.32 2.84 3.142 0 1.864-1.16 3.15-2.84 3.15H8.02v-6.292h2.054zm-.855 5.174h.855c.928 0 1.56-.825 1.56-2.032 0-1.198-.631-2.023-1.56-2.023h-.855v4.055z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.681 29.709h-1.566l-1.79-6.293h1.317l1.256 4.75 1.255-4.75h1.32l-1.792 6.293z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.392 26.558c0-1.823-1.191-3.142-2.839-3.142h-2.054v6.293h2.054c1.679 0 2.839-1.287 2.839-3.15zm-2.839 2.032h-.855v-4.055h.855c.928 0 1.56.825 1.56 2.023 0 1.207-.632 2.032-1.56 2.032zM12 15.709c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4zm2 0c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesDvdFilled;